const defaultState = {
  query: {
    keyword: undefined,
    city_id: undefined,
  },
  listInfo: {
    current   : 1, //目前頁數
    page_size : 10, //一頁幾筆
    total     : 1, //以此query條件，總共幾筆資料
    rows      :[],
  },
}

// action types
const UPDATE_STORE_LIST = 'UPDATE_STORE_LIST';
const UPDATE_STORE_QUERY = 'UPDATE_STORE_QUERY';

// actions
export const updateStoreList  = (listInfo) => ({ type: UPDATE_STORE_LIST, listInfo })
export const updateStoreQuery = (query) => ({ type: UPDATE_STORE_QUERY, query })

// reducers
export default (state = defaultState, action) => {

  var type = action.type

  if (type === UPDATE_STORE_LIST) return { ...state, listInfo: action.listInfo };
  
  if (type === UPDATE_STORE_QUERY) return { ...state, query:action.query };
  
  return state;  
}


// WEBPACK FOOTER //
// ./src/reducers/stores.js